module.exports = __webpack_public_path__ + "static/media/time_management_amber.a96694fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/time_management_amber.svg
// module id = 1084
// module chunks = 2